import axios from "axios";

const instance =  axios.create({baseURL:'https://gohadmin.gohoardings.com/api/v1/'})
instance.defaults.headers.common['Content-Type'] = 'multipart/form-data';
instance.defaults.withCredentials = true;

export default instance;
